export default __webpack_public_path__ + "static/media/ok.d09af470.svg";